import React from "react";
import ReportLayoutSelector from "@core/reports/components/ReportLayoutSelector";
import ReportSectionViewToolbar from "@core/reports/components/ReportSectionViewToolbar";
import { REPORT_TOOLBAR_CLASS } from "@core/reports/constants/reportToolbar";
import type { ReportFormSectionViewMeta } from "@core/reports/api/types";
import type { ReportSectionView, ReportSectionViewLensParams } from "@core/reports/utils/reportSectionViewLens";
import type { AvailableLayoutOption } from "@features/presentationLayout/types/presentationLayout";

type Props = {
  layouts: AvailableLayoutOption[];
  value: string;
  onLayoutChange: (layout: string) => void;
  sectionType: string;
  lens: ReportSectionViewLensParams;
  viewMeta?: ReportFormSectionViewMeta | null;
  excludeViews?: readonly ReportSectionView[];
  onLensChange: (next: ReportSectionViewLensParams) => void;
  className?: string;
};

/** Layout and View for one report or one template tab. The row is the only flex parent, so pieces wrap to the left edge. */
const ReportFilterToolbar: React.FC<Props> = ({
  layouts,
  value,
  onLayoutChange,
  sectionType,
  lens,
  viewMeta,
  excludeViews,
  onLensChange,
  className,
}) => (
  <div className={[REPORT_TOOLBAR_CLASS.root, className].filter(Boolean).join(" ")} data-testid="report-filter-toolbar">
    <div className={REPORT_TOOLBAR_CLASS.row}>
      {layouts.length > 1 ? (
        <div className={REPORT_TOOLBAR_CLASS.control}>
          <ReportLayoutSelector layouts={layouts} value={value} onChange={onLayoutChange} />
        </div>
      ) : null}
      <ReportSectionViewToolbar
        sectionType={sectionType}
        lens={lens}
        viewMeta={viewMeta}
        excludeViews={excludeViews}
        onChange={onLensChange}
      />
    </div>
  </div>
);

export default ReportFilterToolbar;
